import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import GoogleMap from "../../components/map/GoogleMap";

export default function Contact() {
    const { fontSize } = useTheme();
    return (
        <Box sx={{}}>
            <Typography variant="h1" sx={{ fontSize: `${fontSize + 0.5}rem`, margin: "5px 0" }}>Contact Us</Typography>
            <hr />
            <Box sx={{ borderLeft: "5px solid #0b4285", padding: "2px 0 2px 10px", marginTop: "20px", backgroundColor: "whitesmoke", fontSize: `${fontSize + 0.1}rem`, lineHeight: 1.5 }}>
                <div>The Director,</div>
                <div>Meghalaya Society for Social Audit and Transparency (MSSAT),
                </div>
                <div>C/o V. W Bonded Warehouse Near Reliance Office,
                </div>
                <div>Lower Lachumiere, Shillong – 793001,
                </div>
                <div>East Khasi Hills District, Meghalaya.
                </div>
                <div>Email Address : mssatmeghalaya@gmail.com

                </div>
            </Box>
            <br />
            <div style={{ height: "300px" }}>

                <GoogleMap />
            </div>
        </Box>
    )
}